<template>
  <v-sheet height="100%" color="bg1" width="100%">
    <v-sheet class="rounded-tl-lg pa-4">
      <div
        class="pa-2 d-flex align-center"
        style="gap: 8px"
        :class="{
          'flex-wrap': $vuetify.breakpoint.xs,
        }">
        <h3>Task Board Manager</h3>
      </div>
      <v-sheet color="bg1" class="d-flex align-center justify-center rounded mb-1 px-2">
        Task Board Types:
        <v-autocomplete
          :loading="loading"
          :value="selectedTemplate"
          @change="getSelected"
          item-text="name"
          return-object
          :items="entries"
          :placeholder="entries.length ? '' : 'No task types added yet.'"
          background-color="bg1"
          hide-details
          flat
          dense
          solo></v-autocomplete>
        <v-divider class="mx-3 my-1" vertical></v-divider>
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on">
              <v-icon>mdi-menu</v-icon>
            </v-btn>
          </template>
          <v-list dense>
            <v-list-item @click="open()">
              <v-list-item-icon class="mr-2"><v-icon small>mdi-plus</v-icon></v-list-item-icon>
              <v-list-item-title>Add Type</v-list-item-title>
            </v-list-item>
            <v-list-item :disabled="!selectedTemplate" @click="open(selectedTemplate)">
              <v-list-item-icon class="mr-2"
                ><v-icon small>mdi-pencil-outline</v-icon></v-list-item-icon
              >

              <v-list-item-title>Edit Type</v-list-item-title>
            </v-list-item>
            <v-list-item :disabled="!selectedTemplate" @click="del(selectedTemplate.id)">
              <v-list-item-icon class="mr-2"
                ><v-icon color="error" small>mdi-delete-outline</v-icon></v-list-item-icon
              >

              <v-list-item-title>Delete Type</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-sheet>
      <v-tabs>
        <v-tab v-has="permissions.AdminTaskFields.View">Task Fields</v-tab>
        <v-tab v-has="permissions.AdminTaskStatuses.View">Status</v-tab>
        <v-tab>Assigned Users</v-tab>
        <v-tab>Settings</v-tab>
        <v-tab-item v-has="permissions.AdminTaskFields.View" class="overflow-auto" style="height: 78vh">
          <div class="d-flex align-center mt-2">
            <h4 class="mr-2">Sections</h4>
            <v-btn
              v-has="permissions.AdminTaskStatuses.Create"
              small
              color="primary"
              @click="editSection({})"
              class="elevation-0"
              ><v-icon left>mdi-plus</v-icon> Add Section</v-btn
            >
          </div>

          <v-sheet rounded outlined class="mt-2 pa-2" v-if="loadingType || selectedTemplate">
            <v-expansion-panels v-if="selectedTemplate" multiple>
              <draggable
                @end="reOrderSections"
                v-model="selectedTemplate.sections"
                class="flex-grow-1"
                tag="div"
                item-key="id"
                v-bind="dragOptions">
                <v-expansion-panel v-for="(section, i) in selectedTemplate.sections" :key="i">
                  <v-expansion-panel-header>
                    <div class="d-flex align-center">
                      <v-btn
                        class="handle"
                        icon
                        v-has="[permissions.AdminTaskFields.Create, permissions.AdminTaskFields.Update]"
                        ><v-icon>mdi-drag</v-icon></v-btn
                      >
                      <b class="mx-2">{{ section.name }} </b>
                    </div>

                    <span class="d-flex justify-end">
                      <v-btn
                        v-has="permissions.AdminTaskFields.Update"
                        @click.stop="editSection(section)"
                        icon
                        dense>
                        <v-icon small color="success">mdi-pencil-outline</v-icon>
                      </v-btn>
                      <v-btn
                        v-has="permissions.AdminTaskFields.Delete"
                        @click.stop="deleteSection(section.id)"
                        icon
                        dense>
                        <v-icon small color="error">mdi-delete-outline</v-icon>
                      </v-btn>
                    </span>
                  </v-expansion-panel-header>

                  <v-expansion-panel-content>
                    <div class="d-flex align-center">
                      <h4 class="mr-2">Fields</h4>
                      <v-btn
                        v-has="permissions.AdminTaskFields.Create"
                        small
                        color="primary"
                        @click="openField(section, {})"
                        class="elevation-0"
                        ><v-icon left>mdi-plus</v-icon> Add Field</v-btn
                      >
                    </div>
                    <v-data-table
                      class="elevation-0 pa-2 rounded-0 d-flex flex-column table-sticky custom-table"
                      :headers="headers"
                      :loading="loadingType"
                      hide-default-footer
                      :items="selectedTemplate ? section.fields : []">
                      <template v-slot:[`item.createDate`]="{ item }">
                        <div v-if="item.createDate">
                          {{ $formatDate(item.createDate) }}
                        </div>
                      </template>

                      <template v-slot:[`item.isEnabled`]="{ item }">
                        <v-chip x-small :color="item.isEnabled ? 'success' : 'error'">
                          <v-icon x-small> {{ item.isEnabled ? 'mdi-check' : 'mdi-close' }}</v-icon>
                        </v-chip>
                      </template>
                      <template v-slot:[`item.isVisible`]="{ item }">
                        <v-chip x-small :color="item.isVisible ? 'success' : 'error'">
                          <v-icon x-small> {{ item.isVisible ? 'mdi-check' : 'mdi-close' }}</v-icon>
                        </v-chip>
                      </template>
                      <template v-slot:[`item.fieldType`]="{ item }">
                        <v-chip x-small>
                          {{ $getKeyByValue(TaskFieldType, item.fieldType) }}
                        </v-chip>
                      </template>
                      <template v-slot:[`item.color`]="{ item }">
                        <v-alert
                          class="mb-0 px-2 py-1 d-flex justify-center"
                          dense
                          text
                          :color="item.color"
                          style="font-size: x-small; width: 100px">
                          {{ item.color }}
                        </v-alert>
                      </template>
                      <template v-slot:[`item.actions`]="{ item }">
                        <v-menu dense offset-x right>
                          <template v-slot:activator="{ attrs, on }">
                            <v-btn icon elevation="0" v-bind="attrs" v-on="on">
                              <v-icon size="16px">mdi-dots-vertical</v-icon>
                            </v-btn>
                          </template>
                          <v-list class="more-options-menu" dense>
                            <v-list-item
                              v-has="permissions.AdminTaskFields.Update"
                              @click="openField(section, item)"
                              dense>
                              <v-list-item-icon class="mr-2 justify-center">
                                <v-icon small color="success">mdi-pencil-outline</v-icon>
                              </v-list-item-icon>
                              <v-list-item-content>
                                <v-list-item-title>Update</v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                            <v-list-item
                              v-has="permissions.AdminTaskFields.Delete"
                              @click="delField(section.id, item.id)"
                              dense>
                              <v-list-item-icon class="mr-2 justify-center">
                                <v-icon small color="error">mdi-delete-outline</v-icon>
                              </v-list-item-icon>
                              <v-list-item-content>
                                <v-list-item-title> Delete</v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </template>

                      <template v-slot:no-data>
                        <div class="text-center d-flex flex-column">
                          <img
                            width="300"
                            src="/img/notFound.svg"
                            class="py-5 my-8"
                            style="opacity: 0.54" />
                          <p class="font-weight-medium">No Data Available!</p>
                        </div>
                      </template>

                      <template v-slot:loading>
                        <div class="text-center d-flex flex-column">
                          <img
                            width="300"
                            src="/img/loading.svg"
                            class="py-5 my-8"
                            style="opacity: 0.54" />
                          <p class="font-weight-medium">Loading Fields...</p>
                        </div>
                      </template>
                    </v-data-table>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </draggable>
            </v-expansion-panels>
          </v-sheet>
          <v-sheet
            v-if="selectedTemplate"
            color="bg1"
            class="d-flex align-center justify-center rounded mt-2 px-2">
            Grouping By:
            <v-autocomplete
              v-model="selectedTemplate.groupBy"
              item-text="label"
              item-value="id"
              multiple
              small-chips
              @blur="updateType"
              :items="fields"
              placeholder="Select fields for grouping"
              background-color="bg1"
              hide-details
              flat
              dense
              :disabled="!$has(permissions.AdminTaskFields.Grouping)"
              solo></v-autocomplete>
          </v-sheet>
        </v-tab-item>
        <v-tab-item v-has="permissions.AdminTaskStatuses.View">
          <v-sheet rounded outlined class="mt-2 pa-2" v-if="selectedTemplate">
            <div class="d-flex align-center">
              <h4 class="mr-2">Task Status</h4>
              <v-btn
                v-has="permissions.AdminTaskStatuses.Create"
                small
                color="primary"
                @click="openStatus()"
                class="elevation-0"
                ><v-icon left>mdi-plus</v-icon> Add Status</v-btn
              >
            </div>

            <v-data-iterator
              class="elevation-0 pa-2 rounded-0 d-flex flex-column table-sticky custom-table"
              :items="selectedTemplate ? selectedTemplate.statuses : []"
              hide-default-footer
              :loading="loadingType">
              <template v-slot:default="props">
                <draggable
                  @end="reOrderList"
                  v-model="selectedTemplate.statuses"
                  tag="div"
                  item-key="id"
                  v-bind="dragOptions">
                  <template v-slot:header>
                    <v-row class="customRow v-data-table-header" dense>
                      <v-col
                        class="flex-grow-0 px-5"
                        v-has="[
                          permissions.AdminTaskStatuses.Create,
                          permissions.AdminTaskStatuses.Update,
                        ]"></v-col>
                      <v-col
                        :class="{ 'flex-grow-0': header.value === 'actions' }"
                        v-for="header in statusHeader"
                        :key="header.text">
                        {{ header.text }}
                      </v-col>
                    </v-row>
                  </template>
                  <v-row class="customRow" v-for="item in props.items" :key="item.id" dense>
                    <v-col class="flex-grow-0">
                      <v-btn
                        class="handle"
                        icon
                        v-has="[permissions.AdminTaskStatuses.Create, permissions.AdminTaskStatuses.Update]"
                        ><v-icon>mdi-drag</v-icon></v-btn
                      >
                    </v-col>
                    <v-col>
                      {{ item.name }}
                    </v-col>
                    <v-col>
                      <v-alert
                        class="mb-0 px-2 py-1 d-flex justify-center"
                        dense
                        text
                        :color="item.color"
                        style="font-size: x-small; width: 100px">
                        {{ item.color }}
                      </v-alert>
                    </v-col>
                    <v-col>
                      <v-alert
                      v-if="item.statusType"
                        class="mb-0 px-2 py-1 d-flex justify-center"
                        dense
                         text
                        :color="getStatusTypeColor( item.statusType)"
                        style="font-size: x-small; width: 100px">
                        {{getStatusType( item.statusType) }}
                      </v-alert>
                    </v-col>
                    <v-col class="flex-grow-0">
                      <v-menu dense offset-x right>
                        <template v-slot:activator="{ attrs, on }">
                          <v-btn icon elevation="0" v-bind="attrs" v-on="on">
                            <v-icon size="16px">mdi-dots-vertical</v-icon>
                          </v-btn>
                        </template>
                        <v-list class="more-options-menu" dense>
                          <v-list-item
                            v-has="permissions.AdminTaskStatuses.Update"
                            @click="openStatus(item)"
                            dense>
                            <v-list-item-icon class="mr-2 justify-center">
                              <v-icon small color="success">mdi-pencil-outline</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title>Update</v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                          <v-list-item
                            v-has="permissions.AdminTaskStatuses.Delete"
                            @click="delStatus(item.id)"
                            dense>
                            <v-list-item-icon class="mr-2 justify-center">
                              <v-icon small color="error">mdi-delete-outline</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title> Delete</v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </v-col>
                  </v-row>
                </draggable>
              </template>

              <template v-slot:no-data>
                <div class="text-center d-flex flex-column">
                  <img
                    width="300"
                    src="/img/notFound.svg"
                    class="py-5 my-8"
                    style="opacity: 0.54" />
                  <p class="font-weight-medium">No Data Available!</p>
                </div>
              </template>

              <template v-slot:loading>
                <div class="text-center d-flex flex-column">
                  <img width="300" src="/img/loading.svg" class="py-5 my-8" style="opacity: 0.54" />
                  <p class="font-weight-medium">Loading Statuses...</p>
                </div>
              </template>
            </v-data-iterator>
          </v-sheet>
        </v-tab-item>
        <v-tab-item>
          <v-sheet rounded outlined class="mt-2 pa-2">
            <div class="d-flex align-center">
              <h4 class="mr-2">Assigned Users</h4>
              <v-btn small color="primary" class="elevation-0" @click="openAssingUserDialog()"
                ><v-icon left>mdi-account-multiple-plus</v-icon> Assign</v-btn
              >
            </div>
            <v-data-table
              class="elevation-0 pa-2 rounded-0 d-flex flex-column table-sticky custom-table"
              :headers="userHeaders"
              :items="selectedTemplate ? selectedTemplate.users : []"
              :items-per-page="10"
              hide-default-footer>
              <template v-slot:[`item.fullName`]="{ item }">
                {{ item.firstName + ' ' + item.lastName }}
              </template>
              <template v-slot:[`item.email`]="{ item }">
                {{ item.email }}
              </template>
              <template v-slot:[`item.actions`]="{ item }">
                <v-menu dense offset-x right>
                  <template v-slot:activator="{ attrs, on }">
                    <v-btn icon elevation="0" v-bind="attrs" v-on="on">
                      <v-icon size="16px">mdi-dots-vertical</v-icon>
                    </v-btn>
                  </template>
                  <v-list class="more-options-menu" dense>
                    <!-- v-has="permissions.AssignedUsers.Delete" -->
                    <v-list-item @click="unAssignUser(item.id)" dense>
                      <v-list-item-icon class="mr-2 justify-center">
                        <v-icon small color="error">mdi-delete-outline</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title> Delete</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </template>

              <template v-slot:no-data>
                <div class="text-center d-flex flex-column">
                  <img
                    width="300"
                    src="/img/notFound.svg"
                    class="py-5 my-8"
                    style="opacity: 0.54" />
                  <p class="font-weight-medium">No Data Available!</p>
                </div>
              </template>

              <template v-slot:loading>
                <div class="text-center d-flex flex-column">
                  <img width="300" src="/img/loading.svg" class="py-5 my-8" style="opacity: 0.54" />
                  <p class="font-weight-medium">Loading Statuses...</p>
                </div>
              </template>
            </v-data-table>
          </v-sheet>
        </v-tab-item>
        <v-tab-item>
          <v-sheet rounded outlined class="mt-2 pa-4" v-if="selectedTemplate">
            <div class="d-flex align-center mb-3">
              <h4 class="mr-2">Board Settings</h4>
            </div>
            <v-sheet rounded outlined class="pa-4 mb-3">
              <div class="d-flex align-start">
                <v-switch
                  v-model="selectedTemplate.isVerificationBoard"
                  @change="updateType"
                  :loading="updateLoading"
                  hide-details
                  dense
                  inset
                  class="mt-0 pt-0 mr-4"></v-switch>
                <div class="flex-grow-1">
                  <div class="font-weight-medium">Verification Board</div>
                  <div class="text-caption grey--text mt-1" style="line-height: 1.4">
                    When enabled, tasks on this board expose a <strong>Start Verification</strong>
                    action. The action allows tagged items to be measured against design tolerances,
                    capture evidence, and generate verification reports.
                    <br />
                    <em>The Start Verification button is only available on tasks that have at least one linked tag.</em>
                  </div>
                </div>
              </div>
            </v-sheet>
          </v-sheet>
          <v-sheet v-else rounded outlined class="mt-2 pa-4 text-center">
            <p class="grey--text mb-0">Select a task board to configure its settings.</p>
          </v-sheet>
        </v-tab-item>
      </v-tabs>
    </v-sheet>
    <EditType @updateSelected="updateSelected" ref="EditType"></EditType>
    <EditField @updateSelected="updateSelected" ref="EditField"></EditField>
    <EditStatus @updateSelected="updateSelected" ref="EditStatus"></EditStatus>
    <EditSection @updateSelected="updateSelected" ref="editSection"></EditSection>
    <AssignUsers @updateSelected="updateSelected" ref="AssignUsers"></AssignUsers>
  </v-sheet>
</template>

<script>
  import { mapGetters } from 'vuex';
  import EditType from '@TaskManager/components/EditType.vue';
  import EditField from '@TaskManager/components/EditField.vue';
  import EditStatus from '@TaskManager/components/EditStatus.vue';
  import EditSection from '@TaskManager/components/EditSection.vue';
  import AssignUsers from '@TaskManager/components/AssignUsers.vue';
  import headers from '@TaskManager/config/typesFields.headers.js';
  import statusHeader from '@TaskManager/config/status.headers.js';
  import userHeaders from '@TaskManager/config/users.headers.js';

  import { TaskFieldType } from '@Share/config/enums';
  import { $deleteFromArray, $getKeyByValue, $has } from '@/utils';
  import permissions from '@Share/config/permissions';
  import draggable from 'vuedraggable';

  export default {
    computed: {
      ...mapGetters('TASK_MANAGER', {
        loading: 'GET_LOADING',
        entries: 'GET_ENTRIES',
        loadingType: 'GET_LOADING_TYPE',
        loadingStatuses: 'GET_LOADING_TYPE',
        updateLoading: 'GET_UPDATE_LOADING',
      }),
      fields() {
        if (this.selectedTemplate && this.selectedTemplate.sections) {
          let array = this.selectedTemplate.sections.map((e) => e.fields).flat();
          array.unshift(...this.defaultGroups);
          return array;
        } else return [...this.defaultGroups];
      },
      defaultGroups() {
        return [
          { label: 'Contract No', id: 'Project.ContractId' },
          { label: 'Project', id: 'ProjectId' },
          { label: 'Project Manager', id: 'Project.ProjectManagerId' },
          { label: 'WBS Element ID', id: 'Project.WBSElementId' },
          { label: 'Reported By', id: 'ReportedById' },
          { label: 'Approved By', id: 'ApprovedById' },
        ];
      },
      dragOptions() {
        return {
          animation: 400,
        };
      },
    },
    data() {
      return {
        permissions,
        headers,
        selectedTemplate: null,
        TaskFieldType,
        timerId: null,
        statusHeader,
        userHeaders,
         statusTypes:[{
          text:'To Do',
          value:1,
          color:' #615454FF'
        },
      {
          text:'In Progress',
          value:2,
          color:'orange'
        },
      {
          text:'Done',
          value:3,
          color:'green'
        }]
      };
    },
    methods: {
      getStatusType(val){
          var type=this.statusTypes.find(e=>e.value==val);
          if(type) return type.text;
          else return ''
      },
      getStatusTypeColor(val){
          var type=this.statusTypes.find(e=>e.value==val);
          if(type) return type.color;
          else return 'default'
      },
      editSection(section) {
        this.$refs.editSection.open(section, this.selectedTemplate);
      },
      deleteSection(id) {
        this.$store.dispatch('TASK_MANAGER/SECTION_IS_USED', id).then((res) => {
          if (res.isUsed) {
            this.$dialog.warning({
              text: 'This Section Is Already Used By other Tasks In The System, Are You Sure You Want to Delete This Section?',
              title: 'Section already in use',
              actions: {
                false: 'Cancel',
                true: {
                  text: 'Ok',
                  color: 'primary',
                  handle: () => {
                    return this.$store
                      .dispatch('TASK_MANAGER/DELETE_SECTION', {
                        typeId: this.selectedTemplate.id,
                        sectionId: id,
                      })
                      .then(() => {
                        this.updateSelected(this.selectedTemplate);
                      });
                  },
                },
              },
            });
          } else {
            this.$dialog.error({
              text: 'Are you sure you want delete this task section?',
              title: 'Delete Task Section',
              actions: {
                false: 'Cancel',
                true: {
                  text: 'Ok',
                  color: 'primary',
                  handle: () => {
                    return this.$store
                      .dispatch('TASK_MANAGER/DELETE_SECTION', {
                        typeId: this.selectedTemplate.id,
                        sectionId: id,
                      })
                      .then(() => {
                        this.updateSelected(this.selectedTemplate);
                      });
                  },
                },
              },
            });
          }
        });
      },
      $has,
      getSelected(item) {
        this.$store.dispatch('TASK_MANAGER/GET_BY_ID', item.id).then((res) => {
          this.selectedTemplate = res;
          this.selectedTemplate.statuses.sort((a, b) => a.order - b.order);
          this.selectedTemplate.sections.sort((a, b) => a.order - b.order);
        });
      },
      $getKeyByValue,
      open(item) {
        this.$refs.EditType.open(item);
      },
      openField(section, item) {
        this.$refs.EditField.open(section, item, this.selectedTemplate);
      },
      openStatus(item) {
        this.$refs.EditStatus.open(item, this.selectedTemplate);
      },
      openAssingUserDialog() {
        this.$refs.AssignUsers.open(this.selectedTemplate);
      },

      del(id) {
        this.$dialog.error({
          text: 'Are You Sure You Want to Delete This Type?',
          title: 'Delete Task Type',
          actions: {
            false: 'Cancel',
            true: {
              text: 'Ok',
              color: 'primary',
              handle: () => {
                return this.$store.dispatch('TASK_MANAGER/DELETE', id);
              },
            },
          },
        });
      },
      delStatus(id) {
        this.$dialog.error({
          text: 'Are You Sure You Want to Delete This Status?',
          title: 'Delete Status',
          actions: {
            false: 'Cancel',
            true: {
              text: 'Ok',
              color: 'primary',
              handle: () => {
                $deleteFromArray(this.selectedTemplate.statuses, id);
                let data = structuredClone(this.selectedTemplate);
                this.$store.dispatch('TASK_MANAGER/UPDATE', data).then((res) => {
                  this.updateSelected(res);
                });
              },
            },
          },
        });
      },
      delField(sectionId, id) {
        this.$dialog.error({
          text: `Are You Sure You Want to Delete This Field?<h5>* This will remove all data related to this field.</h5> `,
          title: 'Delete Field',
          actions: {
            false: 'Cancel',
            true: {
              text: 'Ok',
              color: 'primary',
              handle: () => {
                const section = this.selectedTemplate.sections.find((elm) => elm.id == sectionId);
                if (!section) {
                  this.$dialog.error({
                    text: 'Section Not Found',
                    title: 'Error',
                  });
                  return;
                }
                $deleteFromArray(section.fields, id);
                let data = structuredClone(this.selectedTemplate);
                this.$store.dispatch('TASK_MANAGER/UPDATE', data).then((res) => {
                  this.updateSelected(res);
                });
              },
            },
          },
        });
      },
      unAssignUser(userID) {
        this.$dialog.error({
          text: `Are You Sure You Want to UnAssign This User ? `,
          title: 'UnAssign User',
          actions: {
            false: 'Cancel',
            true: {
              text: 'Ok',
              color: 'primary',
              handle: () => {
                const user = this.selectedTemplate.users.find((elm) => elm.id == userID);
                if (!user) {
                  this.$dialog.error({
                    text: 'User Not Found',
                    title: 'Error',
                  });
                  return;
                }
                $deleteFromArray(this.selectedTemplate.users, userID);
                let data = structuredClone(this.selectedTemplate);
                this.$store.dispatch('TASK_MANAGER/UPDATE', data).then((res) => {
                  this.updateSelected(res);
                });
              },
            },
          },
        });
      },
      updateSelected(data) {
        this.selectedTemplate = this.entries.find((elm) => elm.id == data.id);
        this.selectedTemplate.statuses.sort((a, b) => a.order - b.order);
        this.selectedTemplate.sections.sort((a, b) => a.order - b.order);
      },
      updateType() {
        const data = structuredClone(this.selectedTemplate);
        if (this.timerId == null) {
          this.timerId = -1;
          this.$store.dispatch('TASK_MANAGER/UPDATE', data).then((res) => {
            this.updateSelected(res);
          });
          return;
        }
        // cancel pending call
        clearTimeout(this.timerId);

        // delay new call 400ms
        this.timerId = setTimeout(() => {
          this.$store.dispatch('TASK_MANAGER/UPDATE', data).then((res) => {
            this.updateSelected(res);
          });
        }, 400);
      },
      reOrderList() {
        this.selectedTemplate.statuses.forEach((status, index) => {
          status.order = index;
        });
        this.updateType();
      },
      reOrderSections() {
        this.selectedTemplate.sections.forEach((status, index) => {
          status.order = index + 1;
        });
        this.updateType();
      },
    },
    components: {
      EditType,
      EditField,
      EditStatus,
      EditSection,
      AssignUsers,
      draggable,
    },

    created() {
      this.$store.dispatch('TASK_MANAGER/GET').then(() => {
        setTimeout(() => {
          if (this.entries.length) this.getSelected(this.entries[0]);
        }, 200);
      });
    },
  };
</script>
<style scoped>
  .handle {
    cursor: move;
  }
  .customRow {
    border-bottom: thin solid var(--v-bg1-base);
    font-size: 0.875rem;
    align-items: center;
  }
  .customRow.v-data-table-header {
    color: var(--v-bg4-lighten1);
  }
</style>
